Monitoring.Views ||= {}

class AccountSettings.ReplyBlacklistsEditorView extends Backbone.View
  template: JST["backbone/templates/account_settings/reply_blacklists/editor"]

  events:
    'change #reply_blacklist-name': 'onChangeName'
    'change #reply_blacklist-active': 'onChangeActivation'
    'change #reply_blacklist-content_visibility': 'onChangeContentVisibility'
    'click #cancel': 'onClickCancel'
    'click #save': 'onClickSave'

  initialize: (@options = {}) ->
    @reply_blacklist          = @options.reply_blacklist
    @all_groups         = @options.groups
    @labelNoneGroup     = @options.labelNoneGroup
    @labelAtLeastOneGroup = @options.labelAtLeastOneGroup
    @originalCode       = @reply_blacklist.get('code')
    @originalName       = @reply_blacklist.get('name')
    @originalActivation = @reply_blacklist.get('active')
    @originalContentVisibility = @reply_blacklist.get('content_visibility').toString()

  render: ->
    @$el.html(@template(@))
    @initializeModal()
    @initializeToggle()

    @isWordsChanged = false
    @isGroupsChanged  = false

    @reply_blacklist_groups = if (@reply_blacklist.get('groups') || []).length == 0 then @reply_blacklist.get('fixed_label_name') else @reply_blacklist.get('groups') || []

    @groupsGroupsView = new Monitoring.Views.ReplyBlacklistGroupsView({
      possibleGroups: @all_groups.map (group) -> group.name
      selectedGroupCodes: @reply_blacklist_groups
      suggestedGroups: []
      withIconAndLabel: false
      toggleableControls: true
      groupsInsteadOfGroups: true
      labelNoneGroup: @labelNoneGroup
      labelAtLeastOneGroup: @labelAtLeastOneGroup
    })
    @$el.find('#groups-list').html(@groupsGroupsView.render())

    @listenTo(@groupsGroupsView, 'changed:groups', @onChangeGroups)

    words = @reply_blacklist.get('words') || []
    @wordsList = new Monitoring.Collections.KeywordsCollection()
    @wordsList.reset( words.map (word) -> { id: word, name: word } )
    @wordsList.on("add change reset", @onChangeWords)
    @keywordsView = new Monitoring.Views.KeywordView({
      keywords: @wordsList,
      entityName: 'reply_blacklist[reply_blacklist_attributes]',
      attributeName: 'words',
      title: '',
      keywordClass: '',
      keywordId: 'keywords-cbo',
      addedKeywordsTemplate: JST["backbone/templates/monitoring/settings/reply_blacklist_added_keywords"],
      renderCleanButton: true
    });
    @$el.find('#words-list').html(@keywordsView.render().el);

    @updateSaveButtonStatus   
    @

 


  initializeModal: ->
    @$el.find('.reply_blacklist-edit').modal()

  initializeToggle: ->
    @$el.find('#reply_blacklist-active').bootstrapToggle({
      # 'on' and 'off' options can be set here
      height: '20px'
    })

  updateSaveButtonStatus: =>
    if @allMandatoryFieldsAreFilled() and (@atLeastOneFieldChanged() or @reply_blacklist.isNew())
      @$el.find('#save').prop('disabled', false)
    else
      @$el.find('#save').prop('disabled', true)

  allMandatoryFieldsAreFilled: =>
    @nameIsFilled() and @wordsIsFilled()

  atLeastOneFieldChanged: =>
    @isNameChanged() or @isActivationChanged() or @isContentVisibilityChanged() or @isGroupsChanged or @isWordsChanged


  codeIsFilled: ->
    @$el.find('#reply_blacklist-code').val().trim().length > 0

  nameIsFilled: ->
    @$el.find('#reply_blacklist-name').val().trim().length > 0
  
  wordsIsFilled: ->
    @keywordsView.keywords.size() > 0


  isNameChanged: =>
    @originalName != @$el.find('#reply_blacklist-name').val().trim()

  isActivationChanged: =>
    @originalActivation != @$el.find('#reply_blacklist-active').prop('checked')

  isContentVisibilityChanged: =>
    @originalContentVisibility != @$el.find('#reply_blacklist-content_visibility').val()


  onChangeName: (evt) ->  
    @updateSaveButtonStatus()

  onChangeActivation: (evt) ->
    @updateSaveButtonStatus()

  onChangeContentVisibility: (evt) ->
    @updateSaveButtonStatus()

  onChangeGroups: (evt) ->
    @isGroupsChanged = true
    @updateSaveButtonStatus()

  onChangeWords: =>
    @isWordsChanged = true
    @updateSaveButtonStatus()
  

  changeCode: ->
    @$el.find('#reply_blacklist-code').val(@$el.find('#reply_blacklist-name').val().replace(/ /g, ''))

  changeTextProperty: (propertyName) ->
    @reply_blacklist.set(propertyName, @$el.find("#reply_blacklist-#{propertyName}").val().trim())

  changeCheckboxProperty: (propertyName) ->
    @reply_blacklist.set(propertyName, @$el.find("#reply_blacklist-#{propertyName}").prop('checked'))


  onClickCancel: ->
    @trigger('cancel')

  onClickSave: ->
    @$el.find('.saving').html(I18n.t('monitoring.reply_blacklist.saving'))

    @changeCode()
    @changeTextProperty('name')
    @changeTextProperty('code')
    @changeCheckboxProperty('active')
    @changeTextProperty('content_visibility')

    @reply_blacklist.set('words', @wordsList.getActiveKeywords().map (k) -> k.get('name'));
    @reply_blacklist.set('groups', @groupsGroupsView.currentlySelectedGroupCodes );

    @reply_blacklist.save({}, {
      success: (response) =>
        @$el.find('.reply_blacklist-edit').modal('hide')
        @trigger('afterSave', @reply_blacklist)
      error: (response) =>
        swal({
          title: I18n.t('monitoring.user_settings.predefined_templates.error.error_on_save')
          type: 'warning'
          showCancelButton: false
          confirmButtonClass: 'btn-success'
          closeOnConfirm: true
        })
        console.log("Error saving alert: #{response}")
        return false
    })
    @$el.find('.saving').html(I18n.t('monitoring.reply_blacklist.save'))
    false
